export default {
  text: 'white',
  primary: '#d8ab01',
  secondary: '#fff685',
  background: 'rgba(37, 37, 37,1)',
  backgroundSecondary: '#fdfdfd',
  light: '#FFF',
  dark: '#020303'
}
